import React, { useState } from 'react'
import { Text, Title } from '@siftscience/focus-components/text'
import { Button, IconButton } from '@siftscience/focus-components/button'
import { Eye, Plus, Warning } from '@siftscience/focus-components/icons'
import { makeStyles } from '@material-ui/core/styles'
import { TemplateDTO } from '../dto/template'
import CustomRuleSetModal from './custom-rule-set-modal'
import { TooltipTrigger } from '@siftscience/focus-components/tooltip'

const RULE_SET_WARNING =
  'Careful when making changes. Adding or removing custom rules will be auto-saved.'

const useStyles = makeStyles(() => ({
  actionBlock: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'flex-end',
    width: '100%',
    padding: '8px 16px',
    borderTop: '1px solid #E0E0E0',
    '& div': {
      lineHeight: 'normal'
    }
  },
  actionButton: {
    display: 'flex',
    flexDirection: 'row'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px'
  },
  exclamation: {
    width: 'auto',
    height: 'auto',
    borderRadius: '50%'
  }
}))

interface CustomRuleSetRowProps {
  readonly?: boolean
  template?: TemplateDTO
}

const CustomRuleSetRow = ({ readonly, template }: CustomRuleSetRowProps) => {
  const [modalState, setModalState] = useState({ visible: false })
  const classes = useStyles()
  const rules = template?.evidenceRules?.[0]?.json_logic_ruleset
  const areRulesEmpty = Object.keys(rules || {})?.length === 0

  const onOpenModal = () => {
    setModalState({ visible: true })
  }

  const onCloseModal = () => {
    setModalState({ visible: false })
  }

  const description = template?.evidenceRules?.[0]?.description

  return (
    <div className={classes.actionBlock}>
      <div>
        <Title size="xsmall" className={classes.title}>
          Custom Rule Set
          {!readonly ? (
            <TooltipTrigger content={RULE_SET_WARNING} placement="top">
              <IconButton
                className={classes.exclamation}
                variant="secondary-ghost"
                size="medium"
              >
                <Warning color="#F2B200" />
              </IconButton>
            </TooltipTrigger>
          ) : null}
        </Title>
        {description ? (
          <div>
            <Text size="xsmall" color="secondary">
              {description}
            </Text>
          </div>
        ) : null}
      </div>
      {readonly && !areRulesEmpty && (
        <Button
          variant="secondary"
          className={classes.actionButton}
          lined
          onClick={onOpenModal}
        >
          <Eye />
          <Title size="xsmall">Show Rule Set</Title>
        </Button>
      )}
      {!readonly && areRulesEmpty && (
        <Button
          variant="secondary"
          className={classes.actionButton}
          lined
          onClick={onOpenModal}
        >
          <Plus />
          <Title size="xsmall">Add Rule Set</Title>
        </Button>
      )}
      {!readonly && !areRulesEmpty && (
        <Button
          variant="secondary"
          className={classes.actionButton}
          lined
          onClick={onOpenModal}
        >
          <Plus />
          <Title size="xsmall">Edit Rule Set</Title>
        </Button>
      )}
      {modalState?.visible ? (
        <CustomRuleSetModal onCloseModal={onCloseModal} template={template} />
      ) : null}
    </div>
  )
}

export default CustomRuleSetRow
